<template>
  <el-container class="outer-container">
    <el-header class="outheader">
      <TopHeader>
      </TopHeader>
    </el-header>
    <el-container class="inner-container">
      <el-aside class="inner-aside">
        <asideMenue></asideMenue>
      </el-aside>
      <el-container class="inner-container2">
    <div v-if="isShowTip" class="headMsgBox">{{msg}}</div>
        <el-header class="header">
          <MainHeader v-if="showMainHeader">
          </MainHeader>
        </el-header>
        <el-main>
          <div style="width:100%">
            <router-view class="roterView" />
            <Footer>
            </Footer>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import asideMenue from '@/components/AsideMenue.vue'
import TopHeader from '@/components/topHeader.vue'
import MainHeader from '@/components/mainHeader.vue'
import Footer from '@/components/footer.vue'
import {
  getServerStatus
} from '@/api/user'
export default {
  components: { asideMenue, TopHeader, Footer, MainHeader },
  data() {
    return {
        isShowTip:false,
        msg:'',
    }
  },
  created() {
    this.getServer()
  },
  methods:{
    getServer() {
      getServerStatus()
        .then((res) => {
          if (res.status == 'ok') {
            if(res.result.status==1||res.result.status==2){
               this.msg = res.result.msg
               this.isShowTip = true
            }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
            this.isShowTip = false
          // this.$message.success('请求失败')
        })
    },
  },
  computed: {
    showMainHeader() {
      return this.$store.state.user.SHowMainHead
    },
    showTopHeader() {
      return this.$store.state.user.SHowTopHead
    },
    key() {
      return this.$route.name
        ? this.$route.name + this.$route.query.toString() + new Date().getTime()
        : this.$route + new Date().getTime()
    },
  },
}
</script>

<style scoped lang="less">
 .headMsgBox{
    height: 50px;
    font-size: 14px;
    padding:15px;
    background-color: #fcf8e3;
    border-color: #faebcc;
    color: #8a6d3b;
}
</style>
